import { AddInError } from './addInError';

export class SecureBeforeYouClickError extends AddInError {
  constructor(message: string, context?: Record<string, unknown>) {
    super(message, context);
    this.name = 'SecureBeforeYouClickError';
    Object.setPrototypeOf(this, SecureBeforeYouClickError.prototype);
  }
}
